import { LoadingController } from "@ionic/angular";
import { Injectable } from "@angular/core";

@Injectable()
export class LoadingComponent {
  isLoading = false;
  loading: any;
  constructor(public loadingController: LoadingController,) {}

  async Loading() {
    this.isLoading = true;
    this.loading = await this.loadingController.create({
      message: "Please wait..."
    });
    await this.loading.present();
  }
  async LoadingDismiss() {
    this.isLoading = false;

    await this.loading.dismiss();
  }
  async LoadingDeleteProperty() {
    this.isLoading = true;
    this.loading = await this.loadingController.create({
      message: "Deleting Property Please wait..."
    });
    await this.loading.present();
  }

  async LoadingProperty() {
    this.isLoading = true;
    this.loading = await this.loadingController.create({
      message: "Loading Property Please wait..."
    });
    await this.loading.present();
  }
}
